import { IAnswer } from './interfaces/answer.interface';
import { IQuestion } from './interfaces/question.interface';

export function deepCopy(obj:{[key:string]:any} | Array<any>):Object | Array<any> {
  if (obj instanceof Array) {
    let newArr = [];
    for (var item of obj) {
      if (typeof item != 'object') {
        newArr.push(item);
      } else newArr.push(deepCopy(item));
    }
    return newArr;
  }

  if (typeof obj == 'object' && obj !== null) {
    let newObj:{[key:string]:any} = {};
    var field:string;

    for (field in obj) if (obj.hasOwnProperty(field)) {
      if (typeof obj[field] != 'object') {
        newObj[field] = obj[field];
      } else newObj[field] = deepCopy(obj[field]);
    }
    return newObj;
  }
  return obj;
}

export function priceFormat(number:number):string {
  return parseFloat(String(number)).toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.)/g, '$1 ') + ' ₽';
}

export function getQueryParam(param:string) {
  var name = param.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(window.location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export function getWeightedRandom<T extends {weight: number}>(list:T[]):T | undefined {
	const sumOfWeights:number = list.reduce((sum, current) => current.weight + sum, 0);
	const randomRange:number = getRandomInt(1, sumOfWeights);
	let counter:number = 0;

	const desiredVariant = list.find(variant => {
		counter += variant.weight;
		if (counter >= randomRange) return variant;
		return undefined;
	});

	return desiredVariant;
}

export function getRandomInt(min:number, max:number):number {
	return Math.floor(min + Math.random() * (max + 1 - min));
}

export function scrollToTop() {
	try {
		window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
	} catch(err) {
	  if (err instanceof TypeError) {
	    window.scroll(0, 0)
	  } else {
	    throw err;
	  }
	}
}

export function componentLoader<T>(lazyComponent: () => Promise<any>, attemptsLeft: number = 20): Promise<T> {
  return new Promise((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error: Error) => {
        setTimeout(() => {
          if (attemptsLeft === 1) {
            reject(error);
            return;
          }
          componentLoader(lazyComponent, attemptsLeft - 1).then(resolve => resolve, reject);
        }, 2000);
      });
  });
}

export function prepareAnswer(question: IQuestion) {
  return {
    question: String(question.header.replace("?", "")),
    answers: question.answers.filter((answer) => answer.checked),
  };
}

export function getActualAnswers(answers: IAnswer[]) {
  return answers.filter(answer => answer.checked).map(answer => answer.value).join(', ');
}

export function checkCondition(questions: IQuestion[], conditions: any[] | undefined): boolean {
  let pass: boolean[] = [];

  if (conditions) for (let condition of conditions) {
    let conditionResults: boolean[] = [];

    for (let operand of condition.operands) {
      let operandResult: boolean = false;
      const answers: IAnswer[] | undefined = questions.find(question => question.id == operand.questionId)?.answers;

      if (!answers) continue;

      for (let operandAnswerId of operand.answers) {
        if (answers.find(answer => answer.id == operandAnswerId)?.checked) {
          operandResult = !operand.exclude;
          if (operand.exclude) break;
        } else {
          operandResult = operand.exclude;
          if (!operand.exclude) break;
        }
      }

      conditionResults.push(operandResult);
    }

    if (condition.require == 'SOME') pass.push(conditionResults.some(result => result));
    if (condition.require == 'EVERY') pass.push(conditionResults.every(result => result))

  }

  return pass.every(result => result);
}